import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { useVoyage } from "../context/VoyageContext";

const VoyageDetails = ({
  staff_dashboard,
  buttonProps,
  buttonShow,
  disabled,
  graphbtn,
}) => {
  const navigate = useNavigate();
  const { voyageState } = useVoyage();

  const boxStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "10px 15px",
    background: "#fff",
    border: "1px solid #f0f0f0",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
    minHeight: "45px",
    transition: "all 0.3s ease",
  };

  const labelStyle = {
    color: "#E11236",
    fontWeight: "700",
    fontSize: "12px",
    textTransform: "uppercase",
    marginRight: "8px",
    letterSpacing: "0.4px"
  };

  const valueStyle = {
    color: "#091e31",
    fontWeight: "600",
    fontSize: "14px"
  };

  return (
    <div className="white-container" style={{ padding: '0', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', borderRadius: '12px', border: '1px solid #f0f0f0' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        background: 'linear-gradient(to right, #091e31, #112d47)',
        padding: '10px 20px',
      }}>
        <h3
          style={{
            textAlign: "left",
            textTransform: "uppercase",
            margin: 0,
            color: '#fff',
            fontSize: '13px',
            fontWeight: '700',
            letterSpacing: '1px'
          }}
        >
          Voyage Details
        </h3>
        
        <div style={{ display: 'flex', gap: '10px' }}>
          {disabled || (graphbtn && (
            <Button
              {...buttonProps}
              disabled={disabled}
              className="save_btn"
              style={{
                background: '#E11236',
                borderColor: '#E11236',
                color: '#fff',
                fontSize: '12px',
                height: '30px',
                borderRadius: '1px',
                ...buttonProps.style,
              }}
              onClick={buttonProps.onclick || (() => navigate("/"))}
            >
              {"Graph Analysis"}
            </Button>
          ))}
          {disabled || (buttonShow && (
            <Button
              {...buttonProps}
              disabled={disabled}
              className="save_btn"
              style={{
                background: '#E11236',
                borderColor: '#E11236',
                color: '#fff',
                fontSize: '12px',
                height: '30px',
                borderRadius: '1px',
                ...buttonProps.style,
              }}
              onClick={buttonProps.onClick || (() => navigate("/"))}
            >
              {buttonProps.text || "Add Logs"}
            </Button>
          ))}
          {!voyageState?.status || (buttonShow && (
            <Button
              {...buttonProps}
              className="save_btn"
              style={{
                background: '#E11236',
                borderColor: '#E11236',
                color: '#fff',
                fontSize: '12px',
                height: '30px',
                borderRadius: '1px',
                ...buttonProps.style,
              }}
              onClick={buttonProps.onPress || (() => navigate("/audit-trail-daily"))}
            >
              {"Audit Trail"}
            </Button>
          ))}
        </div>
      </div>

      <div style={{ padding: '20px' }}>
        <div className="row" style={{ marginBottom: '12px' }}>
          <div className="col-4">
            <div style={boxStyle} className="voyage-info-box">
              <span style={labelStyle}>Voyage Id:</span>
              <span style={valueStyle}>{staff_dashboard?.[0]?.id || "N/A"}</span>
            </div>
          </div>
          <div className="col-4">
            <div style={boxStyle} className="voyage-info-box">
              <span style={labelStyle}>Voyage No:</span>
              <span style={valueStyle}>{staff_dashboard?.[0]?.voyage_no || "N/A"}</span>
            </div>
          </div>
          <div className="col-4">
            <div style={boxStyle} className="voyage-info-box">
              <span style={labelStyle}>Voyage Type:</span>
              <span style={valueStyle}>{staff_dashboard?.[0]?.voyage_type || "N/A"}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <div style={boxStyle} className="voyage-info-box">
              <span style={labelStyle}>Status:</span>
              <span style={valueStyle}>
                {staff_dashboard?.[0]?.voyage_status ? "Running" : "N/A"}
              </span>
            </div>
          </div>
          <div className="col-4">
            <div style={boxStyle} className="voyage-info-box">
              <span style={labelStyle}>Time:</span>
              <span style={valueStyle}>{staff_dashboard?.[0]?.voyage_time || "N/A"}</span>
            </div>
          </div>
          <div className="col-4">
            <div style={boxStyle} className="voyage-info-box">
              <span style={labelStyle}>Date:</span>
              <span style={valueStyle}>{staff_dashboard?.[0]?.voyage_date || "N/A"}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoyageDetails;
